import React from "react";
import { useSelector } from "react-redux";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useNavigate } from 'react-router-dom';

function WaitListScreen() {
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const navigate = useNavigate()
  const registeredData = useSelector((state) => state.register.registeredData);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const toHelp = () => {
    let url = GetBaseUrl(window.location.href);
navigate("/application/help");
    // window.location.replace(url + "/application/help");

  };
  return (
    <div className="progress-title waitlist">
      <div className="greet"> Hello {personalInfo?.firstName}!</div>
      <span className="md-desc">
        Please note that your application for {[ "B.Tech", "B.E."].includes(tokenData?.registrationData?.degree) ? "Engineering" :'MBA'} Scholarship Program is
        currently in the waiting list.
      </span>
      <span className="md-desc">
        In case there is any change in your application status, you will receive
        an email or SMS from us.
      </span>
      <span className="md-desc">
        Application ID: {idInfo.applicationData.salesforceStudentAppNumber}
      </span>
      <span className="md-desc">
        In case of any query, please reach us via{' '}
        <span className="md-desc" onClick={() => toHelp()} style={{cursor:'pointer'}}>
          Help Page
        </span>
      </span>
    </div>
  );
}

export default WaitListScreen;
